import type { AppState } from '@/types'

export type ProjectListItem = {
  id: string
  name: string
  theme: string
  updatedAt: string
  thumbnail: string | null
  shared_owner: string | null
  pending_transfer_member: string | null
  archived: boolean
}

export const selectThreadsPanelState = ({ ui }: AppState) =>
  ui.threadsPanelShown

export const selectSeoPanelState = ({ ui }: AppState) => ui.seoPanelShow
